export function dataAttributes(attr) {
  return attr ? true : undefined;
}

export function ariaAttributes(attr) {
  return Boolean(attr ? true : undefined);
}
